import React, { FC } from "react";
import { Button, FireworksBackground, OnboardingAside, OnboardingContent, WistiaVideo } from "@xapp/components";

import classes from "./PostPayment.module.scss";
import { ClientApp } from "models";

export interface PostPaymentStepProps {
    /**
     * Optional style applied to the root div
     */
    style?: React.CSSProperties;
    /**
     * Optional class name to apply to the root div
     */
    className?: string;

    app?: ClientApp;

    aside?: React.ReactNode;
    /**
     * Callback when user clicks continue
     */
    onNext?: () => void;
}

export const PostPaymentStep: FC<PostPaymentStepProps> = (props) => {
    const { aside, onNext } = props;

    // TODO: SCheduling link?
    return (
        <>
            {aside && <OnboardingAside>{aside}</OnboardingAside>}

            <OnboardingContent>
                <FireworksBackground style={{ height: "100%" }}>
                    <div className={classes.postPaymentContainer}>
                        <div className={classes.videoContainer}>
                            <WistiaVideo videoId="4gfj81jv8b" autoplay={true} muted={true} />
                        </div>

                        {aside && <div className={classes.mobileAside}>{aside}</div>}

                        <Button
                            id={"continueToDashboard"}
                            label="Continue"
                            className={classes.continueButton}
                            onClick={() => {
                                onNext?.();
                            }}
                        />
                    </div>
                </FireworksBackground>
            </OnboardingContent>
        </>
    );
};
